import React from 'react'

export default function About() {
    return (
        <div id="about">
            <div id="aboutImg"></div>
            <div id="aboutText">
                <h4 id="aboutHeading">من نحن</h4><br />
                <h1>تواصل مع أسلوب أحلامك</h1>
                <p>مركز بالي للمساج هو وجهتك المثالية للاسترخاء والعناية بالجسم. نقدم مجموعة متنوعة من الخدمات الفاخرة، بما في ذلك  المساج والحمام المغربي التقليدي، والتي تهدف إلى تجديد حيويتك وتحقيق أقصى درجات الراحة. فريقنا من المختصين المحترفين يحرص على توفير تجربة شخصية ومميزة لكل عميل، مستخدمين أفضل المنتجات والتقنيات لضمان رضاك التام. في مركز بالي، نسعى جاهدين لتوفير بيئة هادئة وفاخرة تمكنك من الهروب من ضغوط الحياة اليومية والاستمتاع بلحظات من السكينة والاستجمام.</p>
                <br />
                <p>في مركز بالي طلاسو، نؤمن بأهمية العناية الشاملة بالصحة والجمال. لذلك، نقدم باقات مخصصة تناسب احتياجات كل عميل، بما في ذلك جلسات العناية بالبشرة والتدليك الإسترخائي. نحن هنا لنساعدك على الوصول إلى أفضل نسخة من نفسك.</p>
            </div>
        </div>
    )
}
